import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

import { postRecessAction } from '../sagas/recess/recessSaga';

// 休会を取得実行します。
const recessService = (action: postRecessAction): any => {
  const postData = {
    member_id: action.memberNo,
    shop_id: action.shopId,
    start_month: action.startMonth,
    end_month: action.endMonth,
  };

  return {
    postRecess: () => apiClient.post(`${API_BASE_ADDRESS}/mypage/member/recess`, postData),
  };
};

export default recessService;
